export default "__VITE_ASSET__ynfqFMbZ__"